import './Status.css'
import { FlexWrapper } from '../Wrappers/Wrappers'

export const WarningStatus = () => {
    return (
        <FlexWrapper alignItems='center' justifyContent='center' className='status-wrapper bg-warning'>
            <svg width="6" height="14" viewBox="0 0 6 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 1.5V8.5" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="3" cy="12" r="1.25" fill="#FFFFFF"/>
            </svg>
        </FlexWrapper>
    )
}
